
    <span
    [pTooltip]="resolvedTooltipText"
    tooltipPosition="top"
    class="button-wrapper">
      <p-button
        [ngClass]="classes"
        [label]="labelText"
        [icon]="iconClass"
        [styleClass]="styleClass"
        [iconPos]="iconPos"
        [disabled]="disabled"
        (onClick)="onClick.emit($event)">
      </p-button>
    </span>
  